export const getAgencyRevenueBreakdownUrl = () => '/agency/revenue/breakdown';

export const getAgencyRevenueAnalyticsUrl = () => '/agency/revenue/analytics';

export const getAgencyMontlyRevenueUrl = (id: number) => `agency/businesses/${id}/billing_histories`;

export const getFetchAgencyBusinessInvoiceUrl = (businessId: number, id: number) =>
  `/agency/businesses/${businessId}/billing_histories/${id}/fetch_invoice`;
